import { ToggleGroup } from '~/components/ui'

type MapBusinessListingFilterProps = {
  business?: 'true' | 'hide'
  updateFilter: (updates: Record<string, any>) => void
}

export default function MapBusinessListingFilter({
  business,
  updateFilter,
}: MapBusinessListingFilterProps) {
  return (
    <div className="space-y-2">
      <p className="text-sm">Business Listings</p>
      <ToggleGroup
        type="single"
        variant="outline"
        size="sm"
        value={business ?? 'all'}
        className="w-full justify-start">
        <ToggleGroup.Item
          value="all"
          className="px-4"
          onClick={() => updateFilter({ business: undefined })}>
          Include
        </ToggleGroup.Item>
        <ToggleGroup.Item
          value="true"
          className="px-4"
          onClick={() => updateFilter({ business: 'true' })}>
          Only Business
        </ToggleGroup.Item>
        <ToggleGroup.Item
          value="hide"
          className="px-4"
          onClick={() => updateFilter({ business: 'hide' })}>
          Exclude
        </ToggleGroup.Item>
      </ToggleGroup>
      <p className="text-sm italic">
        Business locations are intentionally approximate
      </p>
    </div>
  )
}
